import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import closeAddDriver from "../../../../../../assets/images/addDriver/closeAddDiver.svg";
import "./UpdateVehicleInformation.scss";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import Icon from "app/views/commonComponents/Icon/Icon";
import AddInputField from "app/views/commonComponents/AddInputField/AddInputField";
import toastIcon from "../../../../../../assets/images/poc/toastIcon.svg";
import toastCross from "../../../../../../assets/images/poc/toastCross.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateVehicleDetails } from "app/apiServices/apiServices";
const UpdateVehicleInformation = ({
  onClose,
  vehicleId,
  make,
  model,
  type,
  year,
  vinNumber,
  colour,
  licensePlateNumber,
  stateRegistration,
  onVehicleUpdated,
}) => {
  const [vinNumberEdit, setVINNumberEdit] = useState(vinNumber || "");
  const [makeEdit, setMakeEdit] = useState(make || "");
  const [modelEdit, setModelEdit] = useState(model || "");
  const [typeEdit, setTypeEdit] = useState(type || "");
  const [yearEdit, setYearEdit] = useState(year || 0);
  const [licencePlateNumberEdit, setLicencePlateNoEdit] = useState(
    licensePlateNumber || ""
  );
  const [stateRegistrationEdit, setStateRegistrationEdit] = useState(
    stateRegistration || ""
  );
  const [colourEdit, setColourEdit] = useState(colour || "");
  //const [vehicleId, setVehicleId] = useState("");
  const [vinNumberUpdate, setVINNumberUpdate] = useState("");
  const [makeUpdate, setMakeUpdate] = useState("");
  const [modelUpdate, setModelUpdate] = useState("");
  const [typeUpdate, setTypeUpdate] = useState("");
  const [yearUpdate, setYearUpdate] = useState();
  const [licencePlateNumberUpdate, setLicencePlateNoUpdate] = useState("");
  const [stateRegistrationUpdate, setStateRegistrationUpdate] = useState("");
  const [colourUpdate, setColourUpdate] = useState("");
  const [validVINNumber, setValidVINNumber] = useState(false);
  const [validVehicleId, setValidVehicleId] = useState(false);
  const [validLicencePlateNo, setValidLicencePlateNo] = useState(false);
  const [isVehicleUpdated, setIsVehicleUpdated] = useState(false);
  console.log("vehiclId3", vehicleId);
  const updateVehicleDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    const updateVehicleData = {
      vin_number: vinNumberUpdate ? vinNumberUpdate : vinNumberEdit,
      make: makeUpdate ? makeUpdate : makeEdit,
      type: modelUpdate ? modelUpdate : modelEdit,
      model: typeUpdate ? typeUpdate : typeEdit,
      year: yearUpdate ? yearUpdate : yearEdit,
      license_plate_number: licencePlateNumberUpdate
        ? licencePlateNumberUpdate
        : licencePlateNumberEdit,
      state_registration: stateRegistrationUpdate
        ? stateRegistrationUpdate
        : stateRegistrationEdit,
      colour: colourUpdate ? colourUpdate : colourEdit,
    };
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/vehicles/${vehicleId}`,
    //   {
    //     method: "PUT",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       vin_number: vinNumberUpdate ? vinNumberUpdate : vinNumberEdit,
    //       make: makeUpdate ? makeUpdate : makeEdit,
    //       type: modelUpdate ? modelUpdate : modelEdit,
    //       model: typeUpdate ? typeUpdate : typeEdit,
    //       year: yearUpdate ? yearUpdate : yearEdit,
    //       license_plate_number: licencePlateNumberUpdate
    //         ? licencePlateNumberUpdate
    //         : licencePlateNumberEdit,
    //       state_registration: stateRegistrationUpdate
    //         ? stateRegistrationUpdate
    //         : stateRegistrationEdit,
    //       colour: colourUpdate ? colourUpdate : colourEdit,
    //     }),
    //   }
    // ).then((result) => {
    //   if (result.status === 200) {
    //     return result.json();
    //   } else {
    //     alert("Please check login credentials!");
    //   }
    // })
    updateVehicleDetails(vehicleId, updateVehicleData)
      .then((response) => {
        //console.log("insideif", response);
        console.log("addVehicleData", response.data);
        setIsVehicleUpdated(true);
        handleVehicleUpdated(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const handleVehicleUpdated = (value) => {
    onVehicleUpdated(value);
  };
  const updateVinNumber = (e) => {
    let inputValue = e.target.value.toUpperCase(); // Convert input to uppercase
    // Regular expression to match only alphanumeric characters
    const trimmedValue = inputValue.slice(0, 17);
    const validVINNumber = trimmedValue.length === 17;
    setValidVINNumber(validVINNumber);
    const regex = /^[0-9A-Z]{0,17}$/;
    if (regex.test(inputValue)) {
      if (vinNumber) {
        setVINNumberEdit(inputValue);
      } else {
        setVINNumberUpdate(inputValue);
      }
    }
  };
  const updateMake = (e) => {
    if (make != "") {
      setMakeEdit(e.target.value);
    } else {
      setMakeUpdate(e.target.value);
    }
  };
  const updateModel = (e) => {
    if (model != "") {
      setModelEdit(e.target.value);
    } else {
      setModelUpdate(e.target.value);
    }
  };
  const updateType = (e) => {
    if (type != "") {
      setTypeEdit(e.target.value);
    } else {
      setTypeUpdate(e.target.value);
    }
  };
  const updateYear = (e) => {
    if (year != "") {
      setYearEdit(e.target.value);
    } else {
      setYearUpdate(e.target.value);
    }
  };
  const updateLicencePlateNumber = (e) => {
    let inputValue = e.target.value.toUpperCase(); // Convert input to uppercase
    // Regular expression to match only alphanumeric characters
    // const trimmedValue = inputValue.slice(0, 15); // Limit to 5 digits
    // const validVehicleId = trimmedValue.length === 15; // Check if it contains exactly 10 digits
    //setValidVehicleId(validVehicleId);
    const regex = /^[0-9A-Z-]{0,7}$/;
    if (regex.test(inputValue)) {
      if (licensePlateNumber != "") {
        setLicencePlateNoEdit(inputValue);
      } else {
        setLicencePlateNoUpdate(inputValue);
      }
    }
  };
  const updateStateRegistration = (e) => {
    if (stateRegistration != "") {
      setStateRegistrationEdit(e.target.value);
    } else {
      setStateRegistrationUpdate(e.target.value);
    }
  };
  const updateColour = (e) => {
    if (colour != "") {
      setColourEdit(e.target.value);
    } else {
      setColourUpdate(e.target.value);
    }
  };
  return (
    <Card className={"updateVehicleCard"}>
      <CardBody>
        <div className="updateVehicleContainer">
          <div className="updateVehicleTitle">
            <div className="updateVehicleStyle">Update Information</div>
            <Icon
              size="regular"
              buttonType="secondary"
              image={closeAddDriver}
              onClick={onClose}
            ></Icon>
          </div>
          <div className="inputSectionVehicle">
            <div className="inputRowVehicle">
              {/* <AddInputField
                fieldName="Vehicle Id"
                fieldValue={vehicleId}
                onChange={(e) => setVehicleId(e.target.value)}
                style={{ width: "100%" }}
              /> */}
              <AddInputField
                fieldName="VIN Number"
                fieldValue={vinNumberUpdate ? vinNumberUpdate : vinNumberEdit}
                onChange={updateVinNumber}
                style={{ width: "100%" }}
              />
              <AddInputField
                fieldName="Make"
                fieldValue={makeUpdate ? makeUpdate : makeEdit}
                onChange={updateMake}
                style={{ width: "100%" }}
              />
              <AddInputField
                fieldName="Model"
                fieldValue={modelUpdate ? modelUpdate : modelEdit}
                onChange={updateModel}
                style={{ width: "100%" }}
              />
              <AddInputField
                fieldName="Type"
                fieldValue={typeUpdate ? typeUpdate : typeEdit}
                onChange={updateType}
                style={{ width: "100%" }}
              />
            </div>
            <div className="inputRowVehicle">
              <AddInputField
                fieldName="Year"
                fieldValue={yearUpdate ? yearUpdate : yearEdit}
                inputType="number"
                onChange={updateYear}
              />
              <AddInputField
                fieldName="License Plate No."
                fieldValue={
                  licencePlateNumberUpdate
                    ? licencePlateNumberUpdate
                    : licencePlateNumberEdit
                }
                onChange={updateLicencePlateNumber}
              />
              <AddInputField
                fieldName="State Registration"
                fieldValue={
                  stateRegistrationUpdate
                    ? stateRegistrationUpdate
                    : stateRegistrationEdit
                }
                onChange={updateStateRegistration}
              />
              <AddInputField
                fieldName="Color"
                fieldValue={colourUpdate ? colourUpdate : colourEdit}
                onChange={updateColour}
              />
            </div>
          </div>
          <div className="submitButtonVehicle">
            <Buttons
              size={"regular"}
              dimensions={"normal"}
              buttonType={"primary"}
              // disabled={
              //   (makeUpdate == "" && makeEdit == "") || // Both makeAuto and make are empty
              //   (modelUpdate == "" && modelEdit == "") ||
              //   (typeUpdate == "" && typeEdit == "") ||
              //   (yearUpdate == "" && yearEdit == "") ||
              //   // validVehicleId == false ||
              //   validVINNumber == false ||
              //   (licencePlateNumberUpdate == "" &&
              //     licencePlateNumberEdit == "") ||
              //   (stateRegistrationUpdate == "" &&
              //     stateRegistrationEdit == "") ||
              //   (colourUpdate == "" && colourEdit == "")
              // }
              onClick={() => {
                updateVehicleDataAPI();
                onClose();
              }}
            >
              Save Changes
            </Buttons>
          </div>
        </div>
        {/* <ToastContainer
          className={"toast-message"}
          toastStyle={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 12px 8px 8px",
            background: "rgba(0, 188, 249, 0.1)",
            borderRadius: "54px",
            color: "#00bfff",
            fontFamily: "Red Hat Text",
            fontSize: "14px",
            fontWeight: "600",
            //height: "36px",
            minHeight: "none",
          }}
          hideProgressBar={true}
          closeButton={<img src={toastCross} />}
          icon={<img src={toastIcon} />}
        /> */}
      </CardBody>
    </Card>
  );
};

export default UpdateVehicleInformation;
